import { ProductConfigurationResponse } from '../../../../api/ConfigApi';
import apiClient from './apiClient';

const getProductConfigs = async (tenantHostname: string) => {
	const result = await apiClient.get<ProductConfigurationResponse[]>(
		`/products?ns_tenant_host=${tenantHostname}`,
	);
	return result.data;
};

const SsoConfigApi = {
	getProductConfigs,
};

export default SsoConfigApi;
